import { Component } from '@/node_modules/nuxt-property-decorator'
import { ComponentVue } from './ComponentVue'

@Component
export class LayoutComponentVue extends ComponentVue {}
